<template>
  <div class="content">
    <h3 class="header-title clearfix">
      <span>浏览历史</span>
      <el-button class="fr" type="primary" plain size="mini" @click="allDeleteConfirm" v-if="goodList.length">全部清空</el-button>
    </h3>
    <div class="wrapper" v-loading="loading">
      <div class="good-list" v-if="goodList.length">
        <div class="good-wrapper" v-for="good in goodList" :key="good.id">
          <el-button class="star" size="small" type="primary"
                     @click.stop="singleRemove(good)"
                     icon="el-icon-delete" circle></el-button>
          <good-card size="200px" :good="good.commodity"></good-card>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
      </div>
      <empty v-else>暂无收藏商品</empty>
    </div>
  </div>
</template>
<script>
import {footprint_list, footprint_remove} from "@/api/xunyou";
import GoodCard from '@/components/good-card'
import Pagination from '@/components/Pagination';
export default {
  data() {
    return {
      alldelete: false,
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 12,
      goodList: []
    };
  },
  // 注册组件
  components: {GoodCard, Pagination},
  created() {
    this.getHistoryGoods();
  },
  methods: {
    // 全部清空
    allDeleteConfirm () {
      this.$confirm('确定清空浏览历史？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        const params = {
          alldelete: true
        }
        this.removeHistory(params);
      }).catch(() => {
        this.alldelete = false;
      })
    },
    // 单个删除
    singleRemove (good) {
      const params = {
        ids: good.id
      };
      this.removeHistory(params);
    },
    // 删除历史
    removeHistory (params) {
      footprint_remove(params).then(res => {
        console.log('删除历史结果：', res);
        if (res.code === 0) {
          this.$message.success('已删除');
          this.getHistoryGoods();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 翻页
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getHistoryGoods();
    },
    getHistoryGoods() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        uid: this.$store.getters.userId
      }
      this.loading = true;
      footprint_list(params).then((res) => {
        console.log('浏览历史商品：', res);
        this.loading = false;
        if (res.code === 0) {
          this.total = res.total;
          this.goodList = res.rows;
        } else {
          this.$message.error(res.msg);
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("收藏商品查询失败，请稍后再试！");
      });
    }
  }
};
</script>

<style scoped lang="less">
.header-title{
  font-size: 20px;
  color: #666;
}
.good-list{
  padding: 10px 0;
  .good-wrapper{
    position: relative;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    &:nth-child(4n+4) {
      margin-right: 0;
    }
    .star{
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10;
      opacity: 0;
      transition: opacity 0.3s linear;
      box-shadow: 0px 0px 10px rgb(255,168,168);
    }
    &:hover .star{
      opacity: 1;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/myOrder/attentionCenter/goodsHistory.vue